import strings from '../globalization';
import MUTIL from 'mroads-js-utils';
import EventEmitter from './event-emitter';

const LOCATION_TYPE = 'google';

class UTIL {
  static location = {
    latitude: '0',
    longitude: '0',
  };

  static getLocationUsingType = (onSuccess: Function, onError: Function) => {
    try {
      switch (LOCATION_TYPE) {
        // case 'google': {
        //   UTIL.getLocationUsingGooglePlayService(onSuccess, error => {
        //     console.debug('Error getting location', error);
        //     UTIL.location = {
        //       latitude: '0',
        //       longitude: '0',
        //     };
        //     onSuccess('0', '0');
        //   });
        //   break;
        // }
        default: {
          UTIL.location = {
            latitude: '32',
            longitude: '32',
          };
          onSuccess && onSuccess('32', '32');
        }
      }
    } catch (error) {
      onError && onError(error);
    }
  };

  static errorHandling = error => {
    let errorMessage = '';
    let supportMessage = '';
    let errorCode = '';
    if (error.response && error.response.data) {
      errorMessage = error.response.data.message;
      supportMessage = error.response.data.supportMessage;
      errorCode = error.response.data.code;
    } else if (error.message === 'Network Error') {
      errorMessage = strings.networkError;
    }
    // else if (error.message.includes('timeout')) {
    //   errorMessage = strings.timeoutError;
    // }
    else {
      errorMessage = error.message;
      supportMessage = error.supportMessage;
    }
    const tempPayload = {
      errorMessage,
      supportMessage,
      errorCode,
    };
    return tempPayload;
  };

  static formatToPhone(text) {
    if (text) {
      return MUTIL.formatToPhone(text);
    }
    return '';
  }

  static unFormatToPhone = MUTIL.unFormatToPhone;

  static printReceipt = (data, onSuccess, onError, onExtensionUnavailable = null) => {
    if (window.ReactNativeWebView) {
      EventEmitter.sendMessage(data, onSuccess, onError);
    } else {
      const APP_ID = "okdfccnnonjoeenccakpembdfehhbmkh";
      try {
        console.log("window.chrome", window.chrome);
        window.chrome.runtime.sendMessage(APP_ID, data, function (
          response
        ) {
          console.log("response from chrome app", response);
          if (!response) {
            onExtensionUnavailable && onExtensionUnavailable();
            return;
          }
          if (!response.error) {
            // alert("print successful");
            onSuccess && onSuccess(response);
            console.info("print successful", response);
          } else {
            onError && onError(response.error);
            console.info("error in print", response.error);
          }
        });
      } catch (error) {
        onError && onError(error.message);
        console.info("errorrr", error);
      }
    }
  }


   static getCardName = cardType => {
    let text;
    // eslint-disable-next-line default-case
    switch (cardType) {
      case 'JC':
        text = strings.cc_jcb;
        break;
      case 'AX':
        text = strings.cc_amex;
        break;
      case 'VI':
        text = strings.cc_visa;
        break;
      case 'DN':
        text = strings.cc_dn;
        break;
      case 'DI':
        text = strings.cc_discover;
        break;
      case 'MC':
        text = strings.cc_mc;
        break;
    }
    return text;
  };

  static getPaymentType = type => {
    let paymentType;
    switch (type) {
      case 0:
        paymentType = 'CASH';
        break;
      case 1:
        paymentType = 'CREDIT CARD';
        break;
      case 2:
        paymentType = 'APPLE PAY';
        break;
      case 3:
        paymentType = 'GOOGLE PAY';
        break;
      case 4:
        paymentType = 'SAMSUNG PAY';
        break;
      case 5:
        paymentType = 'GIFT CARD';
        break;
      case 6:
        paymentType = 'PAYPAL';
        break;
      case 7:
        paymentType = 'STRIPE';
        break;
      case 8:
        paymentType = 'TOAST CC';
        break;
    }
    return paymentType;
  }

  static getBrowserUniqueId = () => {

    var navigator_info = window.navigator;
    var screen_info = window.screen;
    var uid = navigator_info.mimeTypes.length;
    uid += navigator_info.userAgent.replace(/\D+/g, '');
    uid += navigator_info.plugins.length;
    uid += screen_info.height || '';
    uid += screen_info.width || '';
    uid += screen_info.pixelDepth || '';
    return uid;
  }

  // server app - payment related methods
  static scanMagneticCard = (data, onSuccess, onError) => {
    if (window.ReactNativeWebView) {
      EventEmitter.sendMessage(data, onSuccess, onError);
    }
  }

  static stopMagneticCard = (data, onSuccess, onError) => {
    if (window.ReactNativeWebView) {
      EventEmitter.sendMessage(data, onSuccess, onError);
    }
  }

  static processCreditSale = (data, onSuccess, onError) => {
    if (window.ReactNativeWebView) {
      EventEmitter.sendMessage(data, onSuccess, onError);
    }
  }

  static processPayment = (data, onSuccess, onError) => {
    if (window.ReactNativeWebView) {
      EventEmitter.sendMessage(data, onSuccess, onError);
    }
  }

  static completePayment = (data, onSuccess, onError) => {
    if (window.ReactNativeWebView) {
      EventEmitter.sendMessage(data, onSuccess, onError);
    }
  }

  static round = MUTIL.round;

  static getSeatsForSeatIds = (seatId, check) => {
    const seats = check.seats;
    const seat = seats && seats.filter(each => each.seatId === seatId);
    return seat;
  };

}

export default UTIL;